// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"returnedList_wrapper__2nTuw","header":"returnedList_header__215Me","pagination":"returnedList_pagination__3gthQ"};